import {Component, Inject, Input, OnInit} from '@angular/core';
import {filter, Subject} from "rxjs";
import {AdsService} from "../../core/services/ads.service";
import {AdsRestService} from "../../core/services/api/cms/ads.rest-service";
import {MatomoService} from "../../core/services/matomo.service";
import {UserService} from "../../core/services/user.service";
import {takeUntil} from "rxjs/operators";
import {animate, state, style, transition, trigger} from "@angular/animations";
import {Event, NavigationEnd, Router} from "@angular/router";

@Component({
    selector: 'app-super-banner',
    templateUrl: './super-banner.component.html',
    styleUrl: './super-banner.component.scss',
    standalone: false,
    animations: [
        trigger('slideUpDown', [
            state('visible', style({
                transform: 'translateY(0)',
                opacity: 1,
                height: '90px'
            })),
            state('hidden', style({
                transform: 'translateY(100%)',
                opacity: 0,
                height: '0px'
            })),
            transition('visible => hidden', [
                animate('300ms ease-in-out')
            ]),
            transition('hidden => visible', [
                animate('300ms ease-in-out')
            ])
        ])
    ]
})
export class SuperBannerComponent implements OnInit {
    public ads: any[] = [];
    private ngUnsubscribe$ = new Subject<void>();
    public selected: any = null;
    public hidden = false;
    private position = 'STICKY_BANNER';

    constructor(@Inject(AdsService) private adService: AdsService,
                private adsRestService: AdsRestService,
                private matomoService: MatomoService,
                @Inject(UserService) private userService: UserService,
                @Inject('CDN') public CDN,
                private router: Router) {
    }

    ngOnInit(): void {
        this.updateVisibilityByRoute(this.router.url);
        this.router.events
            .pipe(
                takeUntil(this.ngUnsubscribe$),
                filter((e: Event): e is NavigationEnd => e instanceof NavigationEnd)
            )
            .subscribe((e: NavigationEnd) => {
                this.updateVisibilityByRoute(e.urlAfterRedirects);
            });

        this.refreshAds(false);
    }

    ngOnDestroy(): void {
        this.ngUnsubscribe$.next();
        this.ngUnsubscribe$.complete();
    }

    mtmEvent(action) {
        this.matomoService.trackEvent('Klick auf Ads Banner', action);
    }

    toggleBanner() {
        this.hidden = !this.hidden;
    }

    private updateVisibilityByRoute(url: string) {
        const isDashboard = url === '/dashboard';
        if (isDashboard) {
            const wasHidden = this.hidden;
            this.refreshAds(wasHidden);
            this.hidden = false;
        }
    }

    private refreshAds(pickNewOnReturn: boolean) {
        this.adsRestService.getCurrentAds(this.position)
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe(resp => {
                const allAds: any[] = Array.isArray(resp?.return_object) ? resp.return_object : [];

                let pool = allAds;
                if (!this.userService.isAdmin()) {
                    const prio = allAds.filter(a => a?.prioritized === true);
                    if (prio.length > 0) {
                        pool = prio;
                    }
                }

                this.ads = pool;

                if (this.ads.length === 0) {
                    this.selected = null;
                    return;
                }

                if (pickNewOnReturn && this.selected && this.ads.length > 1) {
                    const candidates = this.ads.filter(a => a.id !== this.selected.id);
                    this.selected = candidates[Math.floor(Math.random() * candidates.length)];
                    return;
                }

                if (!this.selected || !this.ads.some(a => a.id === this.selected.id)) {
                    this.selected = this.adService.showAd(this.ads, true)[0];
                }
            });
    }
}
